import React from "react";

export default function SmallBusinessPlace({data}){
  return(
    <>
    <section className="business-place-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h2 className="heading center-heading">{data?.head}</h2>
            <p>{data?.desc}</p>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}